import * as type from '../actions/types';

const initialState = {
  data: '',
  error: '',
  pending: false,
  success: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.OBEE_UPGRADE_PENDING:
      return {
        ...state,
        pending: true,
        error: '',
      };
    case type.OBEE_UPGRADE_SUCCESS:
      return {
        ...state,
        data: action.payload,
        pending: false,
        success: true,
      };
    case type.OBEE_UPGRADE_FAILURE:
      return {
        ...state,
        pending: false,
        error: action.payload,
      };
    case type.CLEAR_OBEE_UPGRADE:
      return {
        ...state,
        data: '',
        pending: false,
        success: false,
        error: '',
      };

    default:
      return state;
  }
};
